import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import Constant from "../../Constant";

export default class Dashboard extends Component {
  state = {
    domains: [],
    dasboardOptions: [
      {
        id: 0,
        name: "DOMAINS",
        subname: "Add domain",
        link: "/admin/domains",
        subnameLink: "/admin/add-domain",
        icons: <i class="fas fa-globe"></i>,
        type: "superadmin",
      },
      {
        id: 1,
        name: "USERS",
        subname: "Add user",
        link: "/admin/users",
        subnameLink: "/admin/add-user",
        icons: <i class="fas fa-user"></i>,
        type: "both",
      },
      {
        id: 2,
        name: "COURSES",
        subname: "Add course",
        link: "/admin/courses",
        subnameLink: "/admin/add-course",
        icons: <i class="fas fa-book"></i>,
        type: "both",
      },
      {
        id: 3,
        name: "CATEGORIES",
        subname: "Add category",
        link: "/admin/categories",
        subnameLink: "/admin/add-category",
        icons: <i class="fas fa-list-ul"></i>,
        type: "admin",
      },
      {
        id: 4,
        name: "USER TYPES",
        subname: "Add user type",
        link: "/admin/user-types",
        subnameLink: "/admin/add-type",
        icons: <i class="fas fa-user-cog"></i>,
        type: "admin",
      },
      // {
      //   id: 5,
      //   name: "GROUPS",
      //   subname: "Add group",
      //   link: "/admin/groups",
      //   subnameLink: "/admin/add-group",
      //   icons: <i class="fas fa-users"></i>,
      // },
      // {
      //   id: 6,
      //   name: "BRANCHES",
      //   subname: "Add branch",
      //   link: "/admin/branches",
      //   subnameLink: "/admin/add-branch",
      //   icons: <i class="fas fa-code-branch"></i>,
      // },

      {
        id: 7,
        name: "BATCHES",
        subname: "Add Batch",
        link: "/admin/batches",
        subnameLink: "/admin/add-batch",
        icons: <i class="fas fa-layer-group"></i>,
        type: "both",
      },
      // {
      //   id: 8,
      //   name: "SUBSCRIPTIONS",
      //   subname: "Add user type",
      //   link: "/admin/subscriptions",
      //   icons: <i class="fas fa-hand-point-up"></i>,
      //   type: "admin",
      // },
      {
        id: 9,
        name: "REPORTS",
        subname: "Users · Courses · Branches",
        link: "/admin/reports",
        subnameLink: "/admin/reports",
        icons: <i class="fas fa-chart-pie"></i>,
        type: "both",
      },
      {
        id: 10,
        name: "SETTINGS",
        link: "/admin/settings",
        subnameLink: "/admin/settings",
        subname: "Basic Settings · Certification ",
        icons: <i class="fas fa-cog"></i>,
        type: "admin",
      },
      {
        id: 11,
        name: "ACTIVITY LOGS ",
        subname: "Add Event",
        icons: <i class="fas fa-redo-alt"></i>,
        link: "/activity-logs",
        type: "both",
      }
    ],
    data: {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "My Daily Logins",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "rgba(75,192,192,0.4)",
          borderColor: "rgba(75,192,192,1)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgba(75,192,192,1)",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [65, 59, 80, 81, 106, 95, 140],
        },
      ],
    },
  };
  componentDidMount() {
    this.getDomains();
  }
  getDomains = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    // urlencoded.append("siteId", "01650163-d417-4850-a9b6-42eb646eddec");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          console.log(data[i]);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
          data[i].updatedAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
        }
        this.setState({ domains: data, loading: false });
        localStorage.setItem("lms_site_id", data[0].id);
        localStorage.setItem("lms_site_name", data[0].name);
      })
      .catch((error) => console.log("error", error));
  };
  onSelectedOptions = () => { };
  onDomainChange = (e) => {
    this.setState({ categoryId: e.target.value });
    console.log(e.target.value, e.target.id);
    localStorage.setItem("lms_site_id", e.target.value);

    var domains = this.state.domains;
    for (let i = 0; i < domains.length; i++) {
      if (e.target.value === domains[i]) {
        localStorage.setItem("lms_site_name", domains[i].name);
      }
    }
  };
  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row">
              <div className="col-md-8 d-flex align-items-center">
                <h5 className="m-0 p-3">
                  Home / <strong>Dashboard</strong>
                </h5>
              </div>
              <div className="col-md-4">
                {localStorage.getItem("livelms_role") == "superadmin" ? (
                  <div class="form-group row m-0 p-2">
                    <label
                      class="col-form-label col-6 text-right"
                      for="inputDefault"
                      name="categoryId"
                    >
                      Select Domain
                    </label>
                    <select
                      class="custom-select col-6"
                      onChange={this.onDomainChange}
                    >
                      {this.state.domains.map((domain) =>
                        localStorage.getItem("lms_site_id") == domain.id ? (
                          <option value={domain.id} selected>
                            {domain.name}
                          </option>
                        ) : (
                            <option value={domain.id}>{domain.name}</option>
                          )
                      )}
                    </select>
                  </div>
                ) : (
                    ""
                  )}
              </div>
            </div>
          </div>

          <div className="dashboard">
            <div className="row m-0">
              <div className="col-md-6 left-section border-right">
                <div className="row py-2">
                  {this.state.dasboardOptions.map((option) =>
                    localStorage.getItem("livelms_role") == "superadmin"
                      ? (
                        <div className="col-md-6 mb-2">
                          <div
                            onClick={this.onSelectedOptions.bind(this, option.id)}
                            className={`p-2${
                              option.id == this.state.selectedOption
                                ? "selected"
                                : ""
                              }`}
                          >
                            <div className="row admin-option">
                              <div className="col-3">
                                <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                                  {option.icons}
                                </div>
                              </div>
                              <div className="col-9 d-flex align-items-center pl-1">
                                <div className="text">
                                  <Link to={option.link}>
                                    <h5 className="m-0 btn-link">
                                      {option.name}
                                    </h5>
                                  </Link>
                                  <Link to={option.subnameLink} className="m-0">
                                    <p className="text-dark m-0">
                                      {option.subname}
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : localStorage.getItem("livelms_role") == "admin" &&
                        option.type == "admin" ? (
                          <div className="col-md-6 mb-2">
                            <div
                              onClick={this.onSelectedOptions.bind(this, option.id)}
                              className={`p-2${
                                option.id == this.state.selectedOption
                                  ? "selected"
                                  : ""
                                }`}
                            >
                              <div className="row admin-option">
                                <div className="col-3">
                                  <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                                    {option.icons}
                                  </div>
                                </div>
                                <div className="col-9 d-flex align-items-center pl-1">
                                  <div className="text">
                                    <Link to={option.link}>
                                      <h5 className="m-0 btn-link">
                                        {option.name}
                                      </h5>
                                    </Link>
                                    <Link to={option.subnameLink} className="m-0">
                                      <p className="text-dark m-0">
                                        {option.subname}
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : option.type === "both" ? (
                          <div className="col-md-6 mb-2">
                            <div
                              onClick={this.onSelectedOptions.bind(this, option.id)}
                              className={`p-2${
                                option.id == this.state.selectedOption
                                  ? "selected"
                                  : ""
                                }`}
                            >
                              <div className="row admin-option">
                                <div className="col-3">
                                  <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                                    {option.icons}
                                  </div>
                                </div>
                                <div className="col-9 d-flex align-items-center pl-1">
                                  <div className="text">
                                    <Link to={option.link}>
                                      <h5 className="m-0 btn-link">
                                        {option.name}
                                      </h5>
                                    </Link>
                                    <Link to={option.subnameLink} className="m-0">
                                      <p className="text-dark m-0">
                                        {option.subname}
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                            ""
                          )
                  )}
                </div>
              </div>
              <div className="col-md-6 px-0">
                <div className="div m-2">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="btn-group">
                        <div className="btn btn-light active">Today</div>
                        <div className="btn btn-light">Yesterday</div>
                        <div className="btn btn-light">Week</div>
                        <div className="btn btn-light">Month</div>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                      <div className="btn-group">
                        <div className="btn btn-light active">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <div className="btn btn-light">
                          <i class="fas fa-list-ul"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Line data={this.state.data}></Line>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
